module.exports = __webpack_public_path__ + "img/butterfly2.7a861a83.png";